<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles m-3">Crea Pagina Custom </div>
</div>

<!-- Modal body -->
<div class="modal-body">
    <form [formGroup]="formBuilder">
        <div class="row">
            <div class="col-12">
                <div class="m-3 center">
                    <label for="field_title" class="form-label label-fw">Scegli Template</label>
                </div>
            </div>
            <div class="col-6 center">
                <div class="">
                    <label>
                        <input class="checkboxes" type="radio" name="target" [(ngModel)]="template" [ngModelOptions]="{standalone: true}" [value]="'map'">
                        <img alt="" class="img" src="https://backend-dot-fastweb-rivenditori-fe-prod.appspot.com/img/template3.jpg">
                    </label>
                </div>
            </div>
            <div class="col-6 center">
                <div class="">
                    <label>
                        <input class="checkboxes" type="radio" name="target" [(ngModel)]="template" [ngModelOptions]="{standalone: true}" [value]="'clean'">
                        <img alt="" class="img" src="https://backend-dot-fastweb-rivenditori-fe-prod.appspot.com/img/template4.jpg">
                   </label>
                </div>
            </div>
            <div class="col-12 mt-2">
                <div class="m-3">
                    <label for="field_title" class="form-label label-fw">Titolo*</label>
                    <input formControlName="title" name="title" type="text" [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true}" class="form-control form-fw " id="field_title" placeholder="Titolo pagina custom">
                    <div class="invalid-feedback" *ngIf="formControls.title.touched">
                        <span *ngIf="formControls.title.errors && formControls.title.errors?.required">
                            Title is required
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
  <!-- Modal footer -->
  <div class="modal-foot">
    <div class="row my-3 text-center">
        <button type="button" [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false " class="btn btn-fw text me-3"  (click)="clickButtonSave()">Crea</button>
        <button type="button" class="btn btn-outline-fw text" (click)="clickButtonCancel()">Annulla</button>
    </div>
</div>